








import { Component, Vue, Prop } from 'vue-property-decorator';
import AgroTable from '../../components/agroTable/AgroTable.vue';
import Owners from '@/views/owners/Owners.vue';

@Component({
  name: 'Home',
  components: {
    AgroTable,
    owners: Owners
  },
})
export default class Home extends Vue {
  private tableColumns: object[] = [
    { name: "id", label: "ID" },
    { name: "farm", label: "Fazenda" },
    { name: "owner", label: "Proprietário" },
    { name: "locale", label: "Município/Estado" },
    { name: "analysisStatus", label: "Status" },
    { name: "area", label: "Área" },
    { name: "plantation", label: "Cultura"},
    { name: "harvest", label: "Safra"}
  ];
}
